import React, { useState } from 'react';
import styles from './UpgradeForMore.module.scss';
import styles1 from './RemoveWatermark.module.scss';
import icons from '../../assets';
import Button from '../Button';
import { navigateToUpgradePlan } from '../../screens/subscriptionComponents/subscriptionHelper';
import { selectPerImagePremiumPrice } from '../../redux/slicers/imagePaymentFormPopupSlicer';
import { useSelector } from 'react-redux';
import useCurrentOrganizationInfo from '../../hooks/useCurrentOrganizationInfo';
import { openFormInCaseOfNewOrgAndFreemiumUser } from '../../helpers/jsHelper';

const { CrossIcon } = icons;

export const RemoveWatermark = ({ onClose, onClick }) => {
  const pricePerImage = useSelector(selectPerImagePremiumPrice);
  const [loading, setLoading] = useState(false);
  const { hideNewPlans, isFreemiumUser } = useCurrentOrganizationInfo();

  const getCard = ({
    topTitle = 'Single Download',
    topSubTitle = 'You only get this image',
    color = 'dark',
    bottomTitle1 = ' No watermark, High resolution (2160x1440px)',
    bottomTitle2 = 'Commercial usage OK!',
    buttonTitle = `Buy only this for $${pricePerImage}`,
    buttonColor = 'info',
    onBtnClick,
    otherButtonProps = {},
  }) => {
    const element = document.getElementById('mainImage');
    let src = '';
    if (element) {
      src = element.src;
    }
    return (
      <div
        className={`${styles1.card} bg-white d-flex flex-column justify-content-between align-items-center`}>
        <div className="w-100">
          <div
            className={`${styles1.cardTopSection} ${
              color === 'dark' ? styles1.darkBg : styles1.primaryBg
            } w-100 d-flex flex-column justify-content-center align-items-center`}>
            <h5 className={`${styles1.topTitle} m-0`}>{topTitle}</h5>
            <h5 className={`${styles1.topTitleSmall} m-0`}>{topSubTitle}</h5>
          </div>
          <img src={src} alt="Image" className={styles1.image} />
        </div>
        <div className="w-100 d-flex flex-column justify-content-center align-items-center mt-3">
          <h5 className={`${styles1.bottomTitleSmall} m-0`}>{bottomTitle1}</h5>
          <h5
            className={`${styles1.bottomTitleSmall} m-0`}
            dangerouslySetInnerHTML={{ __html: bottomTitle2 }}></h5>
        </div>
        <div
          className={`w-100 ${styles1.buttonContainer} d-flex flex-column justify-content-center align-items-center`}>
          <Button
            size="xs"
            color={buttonColor}
            onClick={onBtnClick}
            fullWidth
            {...otherButtonProps}>
            {buttonTitle}
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div className={`${styles.container} d-flex`}>
      <div className={styles.closeIcon} onClick={onClose}>
        <CrossIcon />
      </div>
      <div className={`${styles.wrapper} ${styles1.wrapper} bg-transparent`}>
        {getCard({
          onBtnClick: async () => {
            setLoading(true);
            await onClick();
            setLoading(false);
            onClose();
          },
          otherButtonProps: {
            loading,
            disabled: loading,
          },
        })}
        {getCard({
          topTitle: 'Unlimited Renders',
          topSubTitle: 'Access to all our tools and templates',
          color: 'primary',
          bottomTitle1: '4K High Resolution, Unlimited Renders',
          bottomTitle2: hideNewPlans || isFreemiumUser
            ? 'No watermarks'
            : 'No watermarks - <span style="font-weight: 600;">$99/month</span>',
          buttonTitle: 'Upgrade plan',
          buttonColor: 'primary',
          onBtnClick: () => {
            if (hideNewPlans || isFreemiumUser) {
              // open enterprise form in case of freemium user whose org is created after 10th Feb 2025
              openFormInCaseOfNewOrgAndFreemiumUser();
            } else {
              navigateToUpgradePlan();
            }
            onClose();
          },
          otherButtonProps: {
            disabled: loading,
          },
        })}
      </div>
    </div>
  );
};
